export default "__VITE_ASSET__BLlB9imj__"